/**
 * 본문 의약품 카드(사진·성상·각인) 크기 CSS — 약사 인쇄 화면(PrintContent)과
 * 케어링노트 탑재뷰(CaringNoteEmbedPage)가 같은 규칙을 공유한다.
 * 'large'가 기존 인쇄 확대 규칙과 동일 (환자용 복약지도문 하위 옵션).
 */

/** 의약품 카드 크기 단계 */
export const DRUG_CARD_SIZES = {
  small: { img: 110, name: 13, text: 12 },
  medium: { img: 150, name: 14, text: 13 },
  large: { img: 200, name: 16, text: 15 },
} as const;

export type DrugCardSize = 'none' | keyof typeof DRUG_CARD_SIZES;

/**
 * 카드 크기 단계에 해당하는 CSS 문자열을 반환한다 — styled-components interpolation에서
 * `${({ $cardSize }) => drugCardSizeCss($cardSize)}` 형태로 쓴다.
 */
export function drugCardSizeCss(cardSize: DrugCardSize): string {
  // '없음': 본문 의약품 카드(사진·성상·각인)를 통째로 숨긴다
  if (cardSize === 'none') {
    return `
      & [data-drug-container="true"] {
        display: none !important;
      }
    `;
  }
  const size = DRUG_CARD_SIZES[cardSize];
  /* 인쇄 미리보기/인쇄 시 약품 이미지 및 텍스트 확대 (환자용) — 크기 단계 적용 */
  return `
    & [data-drug-container="true"] {
      gap: 14px !important;
      padding: 16px !important;
      margin: 12px 0 !important;
      grid-template-columns: ${size.img}px 1fr !important;
      border: 1px solid #ddd !important;
      border-radius: 8px !important;
    }

    & [data-drug-container="true"] img {
      width: ${size.img}px !important;
      height: auto !important;
      min-width: ${size.img}px !important;
    }

    /* 이미지 없음 placeholder도 동일 크기 */
    & [data-drug-container="true"] [data-drug-placeholder="true"] {
      width: ${size.img}px !important;
      height: ${Math.round((size.img * 426) / 780)}px !important;
      min-width: ${size.img}px !important;

      &::after {
        font-size: 14px !important;
      }
    }

    & [data-drug-name="true"] {
      font-size: ${size.name}px !important;
      font-weight: 600 !important;
      /* 줄 수 제한 해제 */
      display: block !important;
      -webkit-line-clamp: unset !important;
      overflow: visible !important;
    }

    & [data-drug-chart="true"] {
      font-size: ${size.text}px !important;
      color: #444 !important;
      line-height: 1.4 !important;
    }

    & [data-drug-print="true"] {
      font-size: ${size.text}px !important;
      color: #444 !important;
      line-height: 1.4 !important;
    }
  `;
}
